/* unplugin-vue-components disabled */import script from "./nav-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./nav-bar.vue?vue&type=script&setup=true&lang=js"

import "./nav-bar.vue?vue&type=style&index=0&id=415cb201&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-415cb201"]])

export default __exports__